module.exports = __webpack_public_path__ + "media/emoj_xihongshi.6ad37ff3.ogg";